import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {useLocation, withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
// import PrintIcon from "@mui/icons-material/Print";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import CloseIcon from "@mui/icons-material/Close";
// import Button from "@mui/material/Button";

import {setLookOpened, setLookOverlayOpened, setLookPageOpened} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import WithSavePostMessage from "../hocs/withSavePostMessage";
// import {featureIsBundle, getBundledFeatures, isInStock} from "../lookNavigation/lookFunctions2";
import {cartItemInStock} from "../lookNavigation/lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {ROUTES} from "../../../routes";
import {isIframe} from "../../../misc/helpers";

const LookListContentHeaderRightSide = (props) => {

  const {intl, isMobile, onBackClick, setLookOverlayOpened, cartItems, userIsLoggedIn, setLookPageOpened, setLookOpened,
    history, withoutSave, fabricatorData} = props;

  const location = useLocation();

  // const printButtonClick = () => {
  //   setLookOverlayOpened(LOOK_OVERLAYS.print)
  // }

  const closeCartClick = () => {
    setLookPageOpened("");
    setLookOpened(null);
    history.push(ROUTES.home);
  }

  const saveButtonClick = (savePostMessage) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListHeaderSave);
    if (userIsLoggedIn) {
      savePostMessage();
    } else {
      const isLixil = isIframe() && fabricatorData.isLixil;
      setLookOverlayOpened(isLixil ? LOOK_OVERLAYS.questionLogin : LOOK_OVERLAYS.leadCapture);
    }
  }

  let itemsToCount = 0;
  cartItems.forEach(cartItem => {
    if (!cartItem.relatedProductParent && cartItemInStock(cartItem)
      // || (featureIsBundle(cartItem.cartFeature, cartItems) && getBundledFeatures(cartItem.cartFeature).some(relFeature => relFeature.dbFeature.lixilAvailableQty > 0))
    ) {
      itemsToCount = itemsToCount + cartItem.quantity
    }
  }); // Items in visualizer should equal total quantity of items minus out of stock (Shower bundle will count as 1 not 7)

  return (
    <div className="ll-header__right">
      {/*<div className="ll-icon" onClick={printButtonClick}>*/}
      {/*  <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}*/}
      {/*              className={"look-icon" + (isMobile ? " look-icon--white2" : "")}>*/}
      {/*    <PrintIcon />*/}
      {/*  </IconButton>*/}
      {/*  {isMobile ? null : (*/}
      {/*    <span className="ll-icon__text">*/}
      {/*      <FormattedMessage id="look.list.header.printButton"/>*/}
      {/*    </span>*/}
      {/*  )}*/}
      {/*</div>*/}
      {withoutSave || fabricatorData.isGrohe || (!IS_PRODUCT_JOURNEY && isMobile) ? null : (
        <WithSavePostMessage>
          {(savePostMessage) => (
            <div className="ll-icon" onClick={() => saveButtonClick(savePostMessage)}>
              <IconButton aria-label={intl.formatMessage({id:"look.list.header.saveButton"})}
                          className={"look-icon" + (isMobile ? " look-icon--white2" : "") + (IS_PRODUCT_JOURNEY ? " look-icon--small2" : "")}>
                <FavoriteBorderIcon />
              </IconButton>
              {isMobile ? null : (
                <span className="ll-icon__text">
                  <FormattedMessage id="look.list.header.saveButton"/>
                </span>
              )}
            </div>
          )}
        </WithSavePostMessage>
      )}
      {!isMobile || !location || !location.pathname ? null : (
        <Fragment>
          {!IS_PRODUCT_JOURNEY && !location.pathname.includes(ROUTES.cart) ? (
            <div className="ll-icon" onClick={onBackClick || closeCartClick}>
              <IconButton aria-label={intl.formatMessage({id:"look.list.header.saveButton"})}
                          className={"look-icon look-icon--small"}>
                <CloseIcon />
              </IconButton>
            </div>
          ) : null}
          {/*{IS_PRODUCT_JOURNEY && (location.pathname === ROUTES.cartLogin) ? (*/}
          {/*  <Button className="look-button look-button--secondary look-button--no-transform"*/}
          {/*          variant="outlined"*/}
          {/*          onClick={() => history.push(ROUTES.cartRegister)}>*/}
          {/*    <FormattedMessage id="grohe.cart.login.mobile.notRegisteredButton"/>*/}
          {/*  </Button>*/}
          {/*) : null}*/}
          {/*{IS_PRODUCT_JOURNEY && (location.pathname === ROUTES.cartRegister) ? (*/}
          {/*  <Button className="look-button look-button--secondary look-button--no-transform"*/}
          {/*          variant="outlined"*/}
          {/*          onClick={() => history.push(ROUTES.cartLogin)}>*/}
          {/*    <FormattedMessage id="grohe.cart.register.mobile.alreadyRegisteredButton"/>*/}
          {/*  </Button>*/}
          {/*) : null}*/}
        </Fragment>
      )}
    </div>
  )
};

LookListContentHeaderRightSide.propTypes = {
  onBackClick: PropTypes.func,
  withoutSave: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {cartItems} = store.cartState;
  const {userIsLoggedIn} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    isMobile,
    cartItems,
    userIsLoggedIn,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setLookOpened,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LookListContentHeaderRightSide)
  )
)
